module.exports = __webpack_public_path__ + "static/img/iphone_room_title2.8ba6473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_title2.png
// module id = tw8f
// module chunks = 0